import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import { InputTextarea } from "primereact/inputtextarea";
import { Calendars } from "../../../components/Calendar/Calendar";
import { deCodeBase64 } from "../../../components/UploadPic/UploadPicUtil";
import { commonUpload } from "../../../service/APP/AppService";
import { DialogConfirm, DialogDelete, DialogViewPic_2 } from "../../../components/DialogService/DialogService";
import { FooterButtonCustomLabel, FooterButtonSigle } from "../../../components/FooterButton/FooterButton";
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { formatDateAPI, formatDateFile, formatDateAPI_V2 } from "../../../utilities/DateUtil";

//PAGE
import P106List_1 from "./P106List_1";
import P106List_2 from "./P106List_2";
import P106Dialog from "./P106Dialog";

//SERVICE
import { pContractorReport2_Info, pContractorReport2_Update, getipAddress } from "../../../service/100/P106Service";
import { genPhotoList, genPhotoUpdate, genContractNoList, genForemanList, genContractRouteList, genGetBranchInfo } from "../../../service/GEN/GenService";
import ValidateService from "../../../components/ValidateService/ValidateService";

import { ciaCameraNameInfo } from "../../../service/CIA/CiaService";
import PCIADialog from "../../CIA/PCIADialog.js";

export default function P106() {
    const toast = useRef(null);
    const history = useHistory();
    const [ip, setIP] = useState("");

    const [deleteDialog, setDeleteDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errData, setErrData] = useState(null);
    const [dataTable, setdataTable] = useState([]);
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [dialogOption, setdialogOption] = useState({
        header: "",
        content: "",
        onConfirm: () => {},
        onCancle: () => {},
        footerBtn: () => {},
    });
    // DATA
    const [formObject, setFormObject] = useState({
        seqPk: 0,
        displayMode: "",
        requestNo: "",
        requestType: "",
        routeName: "",
        orderDetail: "",
        guidelineNo: null,
        fixExpireCheckbox: null,
        fixExpireDate: "",
        urgentFixExpireCheckbox: null,
        urgentFixExpireDate: "",
        replyCheckbox: null,
        replyExpireDate: "",
        replyWithinDay: null,
        locationBegin: "",
        locationEnd: "",
        operateDate: "",
        operateTimeBegin: "",
        operateTimeEnd: "",
        foremanName: "",
        fixedCheckbox: "",
        fixedDate: null,
        notDoneCheckbox: "",
        notDoneNo: null,
        notDoneReason: null,
        otherCheckbox: "",
        otherReason: null,
        supervisorReason: "",
        recordStamp: 0,
        reportDtBegin: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), "09", "00"),
        reportDtEnd: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), "16", "00"),
    });
    const [dataTbImage, setDataTbImage] = useState([]);

    // SEARCH
    const [searchData, setSearchData] = useState({
        requestNo: "",
        userId: "",
        contractNo: "",
    });

    // View Pic
    const [dialogPic, setDialogPic] = useState({ dialog: false, pic: "", show: false });

    //Pic
    const [dialogUpload, setDialogUpload] = useState({ dialog: false, show: false });
    const [dataFile, setDataFile] = useState([]);

    const [contractNoItem, setContractNoItem] = useState([]);
    const [foreMenListItem, setForeMenListItem] = useState([]);
    const [contractRouteItem, setContractRouteItem] = useState([]);

    const [countBtnSave, setCountBtnSave] = useState(0);

    const [ciaCameraId, setciaCameraId] = useState({ciaCameraId: ""});

    const [dialog, setDialog] = useState({
        open: false,
        action: "",
    });

    const [dataSet, setDataSet] = useState({});


    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state) {
                setSearchData({ ...history.location.state, userId: dataUserSession().userId });
            } else {
                history.push("/100");
                // setSearchData({ requestNo: "R651600059", userId: "c16", contractNo: "ป.16-1/64" });
            }
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        getIp();
        getContractorReport2_Info();
        if (searchData.requestNo !== "" && searchData.userId !== "") getGenPhotoList();
        getConstactNo();
    }, [searchData]);

    const getConstactNo = () => {
        const req = { userId: dataUserSession().userId };

        genContractNoList(req).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    let arr = [];
                    res.data.map((item, index) => {
                        if (item.contractNo !== null) arr.push({ name: item.contractNo, code: item.seqPk });
                    });
                    setContractNoItem(arr);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const getContractRouteList = () => {
        const req = { userId: searchData.userId, contractNo: searchData.contractNo };
        genContractRouteList(req).then(
            (res) => {
                setLoading(false);

                let arr = [];
                res.data.map((item, index) => {
                    if (item.routeName !== null) arr.push({ name: item.routeName, code: item.routeNo });
                });
                setContractRouteItem(arr);
                if (res.status === 200) {
                } else {
                    // showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const getForemanList = (contractNo) => {
        const req = { userId: dataUserSession().userId, contractNo: searchData.contractNo };

        genForemanList(req).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    let arr = [];
                    res.data.map((item, index) => {
                        if (item.foremanFullName !== null) arr.push({ name: item.foremanFullName, code: item.foremanId });
                    });

                    setForeMenListItem(arr);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const getContractorReport2_Info = async () => {
        setLoading(true);

        const req = {
            requestNo: searchData.requestNo,
            userId: searchData.userId,
        };

        await pContractorReport2_Info(req).then(
            (res) => {
                // console.log(res);
                setLoading(false);
                if (res.length > 0) {
                    const _data = res[0];
                    setdataTable(res);
                    setFormObject({
                        ...formObject,
                        ..._data,
                        reportDtBegin: _data.reportDtBegin === null ? new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), "09", "00") : _data.reportDtBegin,
                        reportDtEnd: _data.reportDtEnd === null ? new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), "16", "00") : _data.reportDtEnd,
                    });
                    getContractRouteList();
                    getForemanList(_data.contractNo);
                   if(_data.ciaCameraId != null) setciaCameraId({ciaCameraId : _data.ciaCameraId}) ;
                    //setciaCameraId({ciaCameraId : "SSAA_585585_ECBDE"}) 
                }
                // else {
                //     showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                // }


            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const getGenPhotoList = () => {
        setLoading(true);
        const req = {
            userId: searchData.userId,
            requestNo: searchData.requestNo,
            photoType: "C001",
        };
        genPhotoList(req).then(
            (res) => {
                // console.log(res);
                setLoading(false);
                if (res !== undefined) {
                    let temp = [];
                    let index = 0;
                    if (res.data.length) {
                        res.data.forEach((element) => {
                            temp.push({
                                ...element,
                                index: index,
                            });
                            index++;
                        });
                        // setDataTbImage(temp);
                        //

                        if (dataTbImage.length > res.data.length) {
                            res.data.forEach((element1, index) => {
                                dataTbImage.forEach((element2) => {
                                    if (element1.photoSeq === element2.photoSeq) {
                                        temp[index].photoDesc = element2.photoDesc;
                                    }
                                });
                            });
                        } else {
                            dataTbImage.forEach((element, index) => {
                                if (element.photoSeq === temp[index].photoSeq) {
                                    temp[index].photoDesc = element.photoDesc;
                                }
                            });
                        }

                        setDataTbImage(temp);
                    }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const footerButtonConfirm = () => {
        return (
            <FooterButtonSigle
                btnLabel="ปิด"
                onClick={() => {
                    getContractorReport2_Info();
                    setConfirmDialog({ open: false });
                }}
            />
        );
    };
    const footerButtonConfirmS = () => {
        return (
            <FooterButtonSigle
                btnLabel="ปิด"
                onClick={() => {
                    history.push("/100");
                    setConfirmDialog({ open: false });
                }}
            />
        );
    };
    const submitForm = (act) => {
        setLoading(true);

        const req = {
            actionCode: act,
            fixedDate: formObject.fixedDate === null ? "" : formatDateAPI(formObject.fixedDate, false),
            fixedFlag: formObject.fixedCheckbox,
            notDoneFlag: formObject.notDoneCheckbox,
            notDoneNo: formObject.notDoneNo === null ? "" : formObject.notDoneNo,
            notDoneReason: formObject.notDoneReason === null ? "" : formObject.notDoneReason,
            otherFlag: formObject.otherCheckbox,
            otherReason: formObject.otherReason === null ? "" : formObject.otherReason,
            requestNo: searchData.requestNo,
            userId: searchData.userId,
            recordStamp: formObject.recordStamp,
            operateDtBegin: formatDateAPI_V2(formObject.reportDtBegin, true),
            operateDtEnd: formatDateAPI_V2(formObject.reportDtEnd, true),
        };
        pContractorReport2_Update(req).then(
            (res) => {
                setLoading(false);
                if (res.length > 0) {
                    const alert = res[0];
                    // showMessages("success", alert.statusCode === "C" ? "สมบูรณ์" : "มีข้อผิดพลาด", alert.statusText);

                    if (act === "S") {
                        setdialogOption({
                            content: act === "S" && alert.statusCode === "C" ? "ส่งผู้คุมงานเรียบร้อยแล้ว" : alert.statusText,
                            footerBtn: () => footerButtonConfirmS(),
                        });
                    } else {
                        setdialogOption({
                            content: alert.statusText,
                            footerBtn: () => footerButtonConfirm(),
                        });
                    }
                    setConfirmDialog({ open: true });
                } else {
                    showMessages("error", "เกิดข้อผิดพลาด", "บันทึกข้อมูลการรายงานผลผิดพลาด");
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
        if (act === "U") {
            handlerGenPhotoUpdate("U");
        }
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const setValViewForm = (_key) => {
        if (formObject !== undefined) return formObject[_key];
    };
    const setvalForm = (key, val) => {
        setFormObject({ ...formObject, [key]: val });
    };

    const handlerInpusText2 = (val, rowData, key) => {
        const newList = [...dataTbImage];
        const editIndex = newList.findIndex((item) => item.index === rowData.index);
        if (editIndex > -1) {
            let newData = newList[editIndex];
            newData = {
                ...newData,
                [`${key}`]: val,
            };

            newList[editIndex] = newData;
            setDataTbImage(newList);
        }
    };

    const getIp = () => {
        getipAddress().then(
            (res) => {
                setLoading(false);
                setIP(res);
            },
            function (err) {}
        );
    };
    const handlerGenPhotoUpdate = (act, path) => {
        const updatePhoto = (req) => {
            genPhotoUpdate(req).then(
                (res) => {
                    setLoading(false);
                    getGenPhotoList();
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        };

        if (act === "D") {
            const req = {
                actionCode: act,
                originalId: deleteDialog.data.originalId,
                photoDesc: deleteDialog.data.photoDesc,
                photoPath: deleteDialog.data.photoPath,
                photoSeq: deleteDialog.data.photoSeq,
                photoType: "C001",
                requestNo: searchData.requestNo,
                thumbnailPath: deleteDialog.data.thumbnailPath,
                userId: searchData.userId,
            };
            updatePhoto(req);
        } else if (act === "U") {
            for (const iterator of dataTbImage) {
                const req = {
                    actionCode: act,
                    originalId: iterator.originalId,
                    photoDesc: iterator.photoDesc,
                    photoPath: iterator.photoPath,
                    photoSeq: iterator.photoSeq,
                    photoType: "C001",
                    requestNo: searchData.requestNo,
                    thumbnailPath: iterator.thumbnailPath === null ? "" : iterator.thumbnailPath,
                    userId: searchData.userId,
                };
                setTimeout(() => {
                    updatePhoto(req);
                }, 2000);
            }
        } else if (act === "A") {
            const req = {
                actionCode: act,
                originalId: ip,
                photoDesc: "",
                photoPath: path,
                photoSeq: 0,
                photoType: "C001",
                requestNo: searchData.requestNo,
                thumbnailPath: "",
                userId: searchData.userId,
            };

            updatePhoto(req);
        }
    };

    const footerButton = () => {
        const handlerDeleteData = () => {
            handlerGenPhotoUpdate("D");
            setDeleteDialog(false);
        };
        return <FooterButtonCustomLabel labelCon="ยืนยัน" lableCan="ยกเลิก" onClickOk={() => handlerDeleteData()} onClickCancle={() => setDeleteDialog(false)} />;
    };

    const onUploadPic = (obj, i) => {
        setLoading(true);

        const req = {
            base64Pic: deCodeBase64(dataFile[i].fileUpload),
            branchId: obj.branchCode,
            fiscalYear: obj.fiscalYear,
            orderNo: "",
            picName: formatDateFile(new Date(), true) + "_" + i + "_" + searchData.requestNo,
            requestNo: searchData.requestNo,
            userId: searchData.userId,
            picType: dataFile[i].fileUpload.typefile,
        };
        commonUpload(req).then(
            (res) => {
                setLoading(false);
                handlerGenPhotoUpdate("A", res.picPath);

                const old = dataFile[i];
                const modifly = { ...old, picPath: res.picPath, picUrl: res.picUrl };
                setDataFile(modifly);

                if (res !== undefined) {
                } else {
                    showMessages("error", "เกิดข้อผิดพลาด1", "บันทึกข้อมูลการรายงานผลผิดพลาด");
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const handlerOnSavePic = () => {
        for (let i = 0; i < dataFile.length; i++) {
            const req = {
                orderNo: "",
                requestNo: searchData.requestNo,
                userId: searchData.userId,
            };

            genGetBranchInfo(req).then(
                (res) => {
                    setLoading(false);
                    if (res !== undefined) {
                        onUploadPic(res[0], i);
                    } else {
                        showMessages("error", "เกิดข้อผิดพลาด", "บันทึกข้อมูลการรายงานผลผิดพลาด");
                    }
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        }

        setDialogUpload({ dialog: false, show: false });
    };

    const footerButtonCon = (act) => {
        return <FooterButtonCustomLabel labelCon="ยืนยัน" lableCan="ยกเลิก" onClickOk={() => submitForm(act)} onClickCancle={() => setConfirmDialog(false)} />;
    };

    const handlerSettingDialogConfirm = (key) => {
        switch (key) {
            case "S":
                setdialogOption({
                    ...dialogOption,
                    header: "",
                    content: "ต้องการส่งข้อมูลให้ผู้คุมงานหรือไม่",
                    footerBtn: () => footerButtonCon("S"),
                    onCancle: () => setConfirmDialog(false),
                });
                break;
            default:
                break;
        }
        setConfirmDialog({ open: true });
    };

    const display_mode = () => {
        return setValViewForm("displayMode") === "Y" ? true : false;
    };

    const isSelectedBox = (key) => {
        let chk = formObject[key];

        if (chk === "Y" && setValViewForm("displayMode") === "N") {
            return false;
        } else {
            if (chk == "N" || chk == "" || setValViewForm("displayMode") === "Y") {
                return true;
            }
        }
    };

    const viewImage = (event) => {
        setDialogPic({
            dialog: true,
            show: true,
            pic: event.photoPath,
        });
    };

    const disBtnSave = () => {
        return formObject.displayMode === "Y" || countBtnSave !== 0 ? true : false;
    };
    const dis = () => {
        if (formObject.displayMode === "Y") {
            return true;
        } else {
            if (countBtnSave === 0) {
                return true;
            } else {
                return false;
            }
        }
    };


    const onOpenDialog = () => {
        onGetDataInfo(ciaCameraId);
        
    }


    const onGetDataInfo = async (data) => {
        setLoading(true);
        console.log("ciaCameraId we: ", data)
   
            let req = {
                cameraCode : data.ciaCameraId,
                userId: dataUserSession().userId,
            };
    
            await ciaCameraNameInfo(req).then(
                (res) => {
                    setLoading(false);
                    console.log("dataList : ", res.data)
                    if (res.data !== null) {
                        setDialog({ open: true , action: "U"});
                        setDataSet(res.data);
                    } else {
                        showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                    }
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
       
    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="requestType">ประเภทงาน</label>
                                <InputText id="requestType" type="text" disabled={true} maxLength="20" value={setValViewForm("requestType")} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractNo">เลขที่สัญญา</label>
                                <Dropdown id="contractNo" value={searchData.contractNo} optionValue="name" options={contractNoItem} optionLabel="name" optionValue="name" placeholder="เลือก เลขที่สัญญา" disabled={true}></Dropdown>
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="routeNo">เลขที่เส้นทาง</label>
                                <Dropdown id="routeNo" value={setValViewForm("routeName")} optionValue="name" options={contractRouteItem} optionLabel="name" optionValue="name" placeholder="เลือก เลขที่สัญญา" disabled={true}></Dropdown>
                            </div>
                        </div>

                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="requestNo">เลขที่ใบแจ้งฯ</label>
                                <InputText id="requestNo" type="text" disabled={true} maxLength="20" value={setValViewForm("requestNo")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="originalRequestNo">เลขที่ใบแจ้งฯต้นเรื่อง</label>
                                <InputText id="originalRequestNo" type="text" disabled={true} maxLength="20" value={setValViewForm("originalRequestNo")} />
                            </div>
                        </div>

                        <hr />
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-12">
                                <label htmlFor="orderDetail">งานสั่งการเฉพาะอย่าง</label>
                                {/* <InputTextarea id="orderDetail" rows="4" disabled={true} maxLength="1000" value={setValViewForm("orderDetail")} /> */}
                                <P106List_1 dataTable={dataTable} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-col-12">
                                <div className="box">
                                    <div className="p-field-checkbox">
                                        <Checkbox inputId="guidelineCheckbox" checked={setValViewForm("guidelineCheckbox") === "Y" ? true : false} disabled={true} />
                                        <label htmlFor=" guidelineCheckbox">เพื่อเป็นเเนวทางปฏิบัติ</label>
                                        <InputText style={{ marginLeft: "5px", width: "30%" }} id="guidelineNo" type="text" disabled={true} value={setValViewForm("guidelineNo")} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-col-12">
                                <div className="box">
                                    <div className="p-field-checkbox">
                                        <Checkbox inputId="fixExpireCheckbox" checked={setValViewForm("fixExpireCheckbox") === "Y" ? true : false} disabled={true} />
                                        <label htmlFor=" fixExpireCheckbox">เพื่อปรับปรุงแก้ไขภายในวันที่</label>
                                        <InputText style={{ marginLeft: "5px", width: "30%" }} id="fixExpireDate" type="text" disabled={true} value={setValViewForm("fixExpireDate")} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-col-12">
                                <div className="box">
                                    <div className="p-field-checkbox">
                                        <Checkbox inputId="urgentFixExpireCheckbox" checked={setValViewForm("urgentFixExpireCheckbox") === "Y" ? true : false} disabled={true} />
                                        <label htmlFor=" urgentFixExpireCheckbox">เพื่อเร่งรัดดำเนินการโดยด่วน ภายในวันที่</label>
                                        <InputText style={{ marginLeft: "5px", width: "30%" }} id="urgentFixExpireDate" type="text" disabled={true} value={setValViewForm("urgentFixExpireDate")} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-col-12">
                                <div className="box">
                                    <div className="p-field-checkbox">
                                        <Checkbox inputId="replyCheckbox" checked={setValViewForm("replyCheckbox") === "Y" ? true : false} disabled={true} />
                                        <label htmlFor=" replyCheckbox">โปรดตอบเป็นหนังสือภายในวันที่</label>
                                        <InputText style={{ marginLeft: "5px", width: "30%" }} id="replyExpireDate" type="text" disabled={true} value={setValViewForm("replyExpireDate")} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="fixExpireDate">แก้ไขภายในวันที่</label>
                                <InputText id="fixExpireDate" type="text" disabled={true} maxLength="20" value={setValViewForm("fixExpireDate")} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="locationBegin">บริเวณก่อสร้าง</label>
                                <InputText id="locationBegin" type="text" disabled={true} maxLength="20" value={setValViewForm("locationBegin")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="locationEnd">ถึง</label>
                                <InputText id="locationEnd" type="text" disabled={true} maxLength="100" value={setValViewForm("locationEnd")} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="operateTimeBegin">วันที่เวลาขอออกปฏิบัติงานจาก</label>
                                <InputText id="operateTimeBegin" type="text" placeholder="ระบุ เลขที่สัญญา" disabled={true} maxLength="20" value={setValViewForm("operateTimeBegin")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="operateTimeEnd">วันที่เวลาขอออกปฏิบัติงานถึง</label>
                                <InputText id="operateTimeEnd" type="text" placeholder="ระบุ เส้นทาง" disabled={true} maxLength="200" value={setValViewForm("operateTimeEnd")} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="foremanName">หัวหน้างาน</label>
                                <Dropdown id="foremanName" value={setValViewForm("foremanName")} optionValue="name" options={foreMenListItem} optionLabel="name" optionValue="name" placeholder="เลือก เลขที่สัญญา" disabled={true}></Dropdown>
                            </div>
                        </div>
                        <hr />
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label>รายงานผล</label>
                            </div>
                        </div>
                        {/* submit */}
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-2">
                                <div className="p-field-checkbox">
                                    <Checkbox inputId="fixedCheckbox" checked={setValViewForm("fixedCheckbox") === "Y" ? true : false} onChange={(e) => (e.checked === true ? setvalForm("fixedCheckbox", "Y") : setvalForm("fixedCheckbox", "N"))} disabled={display_mode()} />
                                    <label htmlFor="fixedCheckbox">ปรับปรุง/แก้ไข แล้วเสร็จวันที่</label>
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-2">
                                <Calendars key="fixedDate" id="fixedDate" value={setValViewForm("fixedDate") === null ? "" : new Date(setValViewForm("fixedDate"))} onChange={(e) => setvalForm("fixedDate", e.target.value)} disabled={isSelectedBox("fixedCheckbox")} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-2">
                                <div className="p-field-checkbox">
                                    <Checkbox inputId="notDoneCheckbox" checked={setValViewForm("notDoneCheckbox") === "Y" ? true : false} onChange={(e) => (e.checked === true ? setvalForm("notDoneCheckbox", "Y") : setvalForm("notDoneCheckbox", "N"))} disabled={display_mode()} />
                                    <label htmlFor="notDoneCheckbox">ไม่สามารถปรับปรุงแก้ไข ข้อ</label>
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-2">
                                <InputText id="notDoneNo" type="text" maxLength="100" value={setValViewForm("notDoneNo")} onChange={(e) => setvalForm("notDoneNo", e.target.value)} disabled={isSelectedBox("notDoneCheckbox")} />
                            </div>
                            <div className="p-field p-col-12 p-sm-1" style={{ textAlign: "right" }}>
                                <label htmlFor="guideline_no">เหตุผล</label>
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <InputText id="notDoneReason" type="text" maxLength="100" value={setValViewForm("notDoneReason")} onChange={(e) => setvalForm("notDoneReason", e.target.value)} disabled={isSelectedBox("notDoneCheckbox")} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-2">
                                <div className="p-field-checkbox">
                                    <Checkbox inputId="otherCheckbox" checked={setValViewForm("otherCheckbox") === "Y" ? true : false} onChange={(e) => (e.checked === true ? setvalForm("otherCheckbox", "Y") : setvalForm("otherCheckbox", "N"))} disabled={display_mode()} />
                                    <label htmlFor="otherCheckbox">อื่นๆ</label>
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-7">
                                <InputText id="otherReason" type="text" maxLength="100" value={setValViewForm("otherReason")} onChange={(e) => setvalForm("otherReason", e.target.value)} disabled={isSelectedBox("otherCheckbox")} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="reportDtBegin">วันที่เวลาออกปฏิบัติงานจาก</label>
                                <span style={{ color: "red" }}>*</span>
                                <Calendars key="reportDtBegin" id="reportDtBegin" value={new Date(setValViewForm("reportDtBegin"))} onChange={(e) => setvalForm("reportDtBegin", e.target.value)} disabled={display_mode()} showTime={true} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="reportDtEnd">วันที่เวลาออกปฏิบัติงานถึง</label>
                                <span style={{ color: "red" }}>*</span>
                                <Calendars key="reportDtEnd" id="reportDtEnd" value={new Date(setValViewForm("reportDtEnd"))} onChange={(e) => setvalForm("reportDtEnd", e.target.value)} disabled={display_mode()} showTime={true} />
                            </div>
                        </div>

                        <P106List_2 dataTable={dataTbImage} setDeleteDialog={setDeleteDialog} setheadlerInpusText={handlerInpusText2} viewImage={viewImage} dialogUploadPic={setDialogUpload} displayMode={display_mode} />
                        <br />

                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="requestNo">เหตุผลจากผู้ควบคุมงาน</label>
                                <InputTextarea id="supervisorReason" value={setValViewForm("supervisorReason")} rows="4" disabled={true} />
                            </div>
                        </div>

                        <div className="p-grid" style={{ textAlign: "center" }}>
                            <div className="p-col-12">
                                <div className="p-grid" style={{ textAlign: "center" }}>
                                    <div className="p-col-2"></div>
                                    <div className="p-col-4">
                                        <Button
                                            className="p-button-success p-button p-mr-2 p-mb-2"
                                            icon="pi pi-save"
                                            label="บันทึก"
                                            style={{ width: 170 }}
                                            onClick={() => {
                                                submitForm("U");
                                                setCountBtnSave(1);
                                            }}
                                            disabled={disBtnSave()}
                                        />
                                        <Button
                                            className="p-button-secondary p-button p-mr-2 p-mb-2"
                                            icon="pi pi-arrow-left"
                                            label="กลับหน้าจอหลัก"
                                            // style={{ marginLeft: '5px' }}
                                            style={{ width: 170, marginLeft: "5px" }}
                                            onClick={() => history.push("/100")}
                                        />
                                    </div>
                                    <div className="p-col-4">
                                        <Button
                                            className="p-button-warning p-button p-button p-mr-2 p-mb-2"
                                            icon="pi pi-sign-in"
                                            label="ส่งผู้คุมงาน"
                                            // style={{ marginLeft: '5px' }}
                                            style={{ width: 170, marginLeft: "5px" }}
                                            onClick={() => handlerSettingDialogConfirm("S")}
                                            disabled={dis()}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <DialogViewPic_2 dialog={dialogPic} data={dialogPic.pic} modal setDialogPic={setDialogPic} />
                    <P106Dialog dialog={dialogUpload} setDialog={setDialogUpload} dataFile={dataFile} setDataFile={setDataFile} typeFile="jpg" onSaveFile={handlerOnSavePic} onOpenDialog={onOpenDialog}/>
                    <DialogDelete visible={deleteDialog.open} header="การยืนยัน" modal footer={footerButton()} onHide={() => setDeleteDialog(false)} textContent="คุณต้องการลบข้อมูล ใช่หรือไม่ ?" />
                    <DialogConfirm visible={confirmDialog.open} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setConfirmDialog(false)} textContent={dialogOption.content} />
                    <PCIADialog dialog={dialog} setDialog={setDialog} dataSet={dataSet} ></PCIADialog>
                </div>
            </div>
        </>
    );
}
